import React, { Component } from "react";
import InfoDialogSubtitleViewStyle from "./InfoDialogSubtitleViewStyle";

export default class InfoDialogSubtitleView extends Component {

    private _style = new InfoDialogSubtitleViewStyle();

    render() {
        return(
            <span style={this._style.subtitle}>
                {this.props.children}
            </span>
        );
    }
}